<script>
import appConfig from "@/app.config";
import Cookies from 'js-cookie'
import NavBarAuth from '@/components/navbar-auth';
import FooterAuth from '@/components/footer-auth';

import {
  required,
  email,
} from "vuelidate/lib/validators";

/**
 * Login component
 */
export default {
  name: "Login",
  page: {
    title: "Login",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { NavBarAuth, FooterAuth },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      isAuthError: false,
      errorMessage: null,
      isPasswordShowed: false
    };
  },
  validations: {
    form: {
      email: { required, email },
      password: { required },
    }
  },
  computed: {
    inputPasswordType() {
      return this.isPasswordShowed ? 'text' : 'password';
    }
  },
  methods: {
    tryToLogIn() {
      // stop here if form is invalid
      this.$v.$touch();
      if (!this.$v.$invalid) {
        // hit api disini
        this.$axios.post('/v1/logistic_company/login', this.form)
          .then(response => {
            let userdata = response.data.data;
            this.$store.commit("SET_LOGIN", userdata);
            Cookies.set("userdata", JSON.stringify(userdata), { expires: 1 }); 
            window.location.reload();
          }).catch(error => {
            this.isAuthError = true;
            this.errorMessage = error.response.data.message;
          })
      }
    }
  }
};
</script>

<template>
  <div class="front-page account-pages mt-5">
    <NavBarAuth />
    <div class="front-bg"></div>
    <div class="container mt-5 pt-4">
      <div class="row justify-content-center mt-5">
        <div class="col-md-8 col-lg-6 col-xl-6">
          <div class="card overflow-hidden">
            <div class="text-semi-black text-center pt-5">
              <h1>{{ $t('auth.login_title') }}</h1>
            </div>
            <div class="card-body px-5 pt-0">
              <div class="p-3">
                
                <b-alert
                  v-model="isAuthError"
                  class="mt-3"
                  variant="danger"
                  dismissible
                >{{ errorMessage }}</b-alert>

                <b-form @submit.prevent="tryToLogIn" class="form-horizontal mt-2">
                  <b-form-group id="email-group" label="Email" label-for="email">
                    <b-form-input
                      id="email"
                      name="email"
                      v-model.trim="form.email"
                      :class="{ 'is-invalid': $v.form.email.$error }"
                      type="text"
                    ></b-form-input>
                    <div v-if="$v.form.email.$error" class="invalid-feedback">
                      <span v-if="!$v.form.email.required">{{ $t('form.validation.required', { field: 'Email' }) }}</span>
                      <span v-if="!$v.form.email.email">{{ $t('form.validation.email', { field: 'Email' }) }}</span>
                    </div>
                  </b-form-group>

                  <b-form-group
                    id="password-group"
                    label="Password"
                    label-for="password"
                    class="mb-3 input-password"
                  >
                    <b-form-input
                      id="password"
                      name="password"
                      v-model="form.password"
                      :class="{ 'is-invalid': $v.form.password.$error }"
                      :type="inputPasswordType"
                    ></b-form-input>
                    <i class="fas pass-icon" :class="[ isPasswordShowed ? 'fa-eye' : 'fa-eye-slash']" @click="isPasswordShowed = !isPasswordShowed"></i>
                    <div v-if="$v.form.password.$error" class="invalid-feedback">
                      <span v-if="!$v.form.password.required">{{ $t('form.validation.required',{ field: 'Password' }) }}</span>
                    </div>
                  </b-form-group>

                  <div class="form-group row">
                    <div class="col-sm-12 text-right">
                      <router-link tag="a" to="/forgot-password" class="text-danger">
                        {{ $t('auth.forgot_password') }} ?
                      </router-link>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-sm-12 ">
                      <b-button type="submit" variant="danger" size="lg" class="w-100">Log In</b-button>
                    </div>
                  </div>

                  <div class="form-group mt-2 mb-0 row">
                    <div class="col-12 mt-2 text-center">
                      <p class="hr-lines">{{ $t('auth.no_account') }} ?</p>
                      <b-button type="button" to="/register" size="lg" variant="outline-danger" class="w-100 mt-3">{{ $t('auth.register') }}</b-button>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
            <!-- end card-body -->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <FooterAuth />
  </div>
</template>

<style lang="css" scoped>
.hr-lines:before{
  content:" ";
  display: block;
  height: 2px;
  width: 120px;
  position: absolute;
  top: 50%;
  left: 0;
  background: #5b626b;
}
.hr-lines{
  position: relative;
  /*  new lines  */
  max-width: 500px;
  margin: 10px auto;
  text-align: center;
}
.hr-lines:after{
  content:" ";
  height: 2px;
  width: 120px;
  background: #5b626b;
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
}
</style>
